
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ImpersonationState extends BaseYcState {

}
